export const NAMESPACE = "PortalPageTrainingCenter";

export const PAGE_ACTIONS = {
  MARK_AS_COMPLETED: "mark_as_completed"
};
